module.exports = __webpack_public_path__ + "static/pasha-icon-0b68a339c04587a1d4ca955e4f757137.svg";